import { useContext, useEffect, useState } from "react";
import SwitchBox from "./SwitchBox";
import SwitchButton from "./SwitchButton";
import BankCard from "./BankCard";
import axios from "../../axios/axios";
import { Button, ButtonBase, Pagination } from "@mui/material";
import { Close } from "@mui/icons-material";
import SortBy from "./SortBy";
import LoaderComp from "../../components/LoaderComp";
import PageLoader from "../../components/PageLoader";
import BonusSwitchBox from "./BonusSwitchBox";
import ViewBonusPopup from "./ViewBonusPopup";
import InHouseModal from "./InHouseModal";
import { setFilters } from "../../redux/slice/loanFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AuthenticationContext } from "../../App";
import { toast } from "react-toastify";

const LoanProduct = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { authData } = useContext(AuthenticationContext);
  const accessToken = localStorage.getItem("agentModuleToken");
  const filters = useSelector((state) => state.loanProductFilter.filters);
  const settings = useSelector((state) => state.settings);

  const DefaultFilters = {
    category: settings.categories[0].id,
    vehicle: settings.vehicles[0].id,
    loanType: settings.categories[0].types[0].id,
    scheme: settings.categories[0].types[0].schemes[0].id,
    motorType: settings.productMotorTypes[0].id,
    usage: settings.productUsages[0].id,
    approvalTime: settings.approvalTimes[0].id,
    ltv: settings.ltvs[0].id,
    bonus: "",
    toggleSwitch: "lt",
    status: 1,
    approvalTime: settings.approvalTimes[0].id,
    index: "0",
    keyword: "", // search
    //productType: "", // top filter
    sortKey: "name", // name
    sortOrder: "asc", // asc
    collect_first_installment: "",
  };
  const [applyFilters, setApplyFilters] = useState(
    Object.keys(filters)?.length > 0
      ? { ...DefaultFilters, ...filters }
      : DefaultFilters
  );

  const [tabIdx, setTabIdx] = useState(0);
  const [bonusPopUp, setbonusPopUp] = useState(false);
  const [inHouseModal, setinHouseModal] = useState(false);
  const [inHouseEdit, setinHouseEdit] = useState({
    prodEdit: false,
    id: "",
  });
  const [allAgentData, setallAgentData] = useState(null);
  const [searchKeyWord, setSearchKeyWord] = useState(
    filters?.keyword !== "" ? filters?.keyword : ""
  );
  const [dynamicParam, setDynamicParam] = useState({});
  const [loading, setLoading] = useState(false);
  const [mobfilterBar, setmobfilterBar] = useState(false);
  const [switchButton, setSwitchButton] = useState(true);
  const [settingsData, setSettingsData] = useState(null);
  const [settingsIndex, setSettingsIndex] = useState(Object.keys(filters).length > 0 &&
    filters?.settingIndex !== undefined
    ? filters?.settingIndex
    : {
      veh: 0,
      cat: 0,
      typ: 0,
      schm: 0,
    }
  );
  const [loanProducts, setLoanProducts] = useState(null);
  const [loanCounts, setLoanCounts] = useState(null);
  const [productPages, setProductPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagePermissions, setPagePermissions] = useState({});
  const [totalData, setTotalData] = useState(0);
  const [agentId, setAgentId] = useState(null);
  const Reset = () => {
    setCurrentPage(1);
    setLoanProducts([]);
  }

  useEffect(() => {
    if (
      location?.state !== "" &&
      location?.state !== undefined &&
      location?.state !== null &&
      Object.keys(location.state)?.length > 0
    ) {
      setPagePermissions(location?.state);
    }
  }, [location]);

  /*
   Object.keys(filters)?.length > 0
      ? { ...DefaultFilters, ...filters }
      : DefaultFilters
  */
  const settingsHandle = (idx, title, tabId) => {
    Reset();
    switch (title) {
      case "vehicle":
        setSettingsIndex({ ...settingsIndex, veh: idx, typ: 0 });
        setApplyFilters({
          ...applyFilters,
          vehicle: settingsData.vehicles[idx].id
        });
        dispatch(
          setFilters({
            ...applyFilters,
            vehicle: settingsData.vehicles[idx].id
          })
        );
        break;
      case "category":
        setSettingsIndex({ ...settingsIndex, cat: idx, typ: 0 });
        setApplyFilters({
          ...applyFilters,
          category: settingsData.categories[idx].id,
          loanType: settingsData.categories[idx].types[0].id,
          scheme: settingsData.categories[idx].types[0].schemes[0].id,
          settingIndex: { ...settingsIndex, cat: idx, typ: 0 },
        });
        dispatch(
          setFilters({
            ...applyFilters,
            category: settingsData.categories[idx].id,
            loanType: settingsData.categories[idx].types[0].id,
            scheme: settingsData.categories[idx].types[0].schemes[0].id,
            settingIndex: { ...settingsIndex, cat: idx, typ: 0 },
          })
        );
        break;
      case "type":
        setSettingsIndex({ ...settingsIndex, typ: idx, schm: 0 });
        setApplyFilters({
          ...applyFilters,
          loanType: tabId,
          scheme:
            settingsData.categories[settingsIndex.cat].types[idx].schemes[0].id,
          settingIndex: { ...settingsIndex, typ: idx, schm: 0 },

        });
        dispatch(
          setFilters({
            ...applyFilters,
            loanType: tabId,
            scheme:
              settingsData.categories[settingsIndex.cat].types[idx].schemes[0]
                .id,
            settingIndex: { ...settingsIndex, typ: idx, schm: 0 },

          })
        );
        break;
      case "scheme":
        setSettingsIndex({ ...settingsIndex, schm: idx });
        setApplyFilters({
          ...applyFilters,
          loanType:
            settingsData.categories[settingsIndex.cat].types[settingsIndex.typ]
              .id,
          scheme: tabId,
          settingIndex: { ...settingsIndex, schm: idx },

        });
        dispatch(
          setFilters({
            ...applyFilters,
            loanType:
              settingsData.categories[settingsIndex.cat].types[
                settingsIndex.typ
              ].id,
            scheme: tabId,
            settingIndex: { ...settingsIndex, schm: idx },

          })
        );
        break;
      case "motor":
        setApplyFilters({
          ...applyFilters,
          motorType: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            motorType: tabId,
          })
        );
        break;
      case "usage":
        setApplyFilters({
          ...applyFilters,
          usage: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            usage: tabId,
          })
        );
        break;
      case "approval time":
        setApplyFilters({
          ...applyFilters,
          approvalTime: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            approvalTime: tabId,
          })
        );
        break;
      case "loan to value":
        setApplyFilters({
          ...applyFilters,
          ltv: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            ltv: tabId,
          })
        );
        break;
      case "bonus":
        setApplyFilters({
          ...applyFilters,

          bonus: idx === 0 ? "" : idx === 2 ? "0" : "1",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            bonus: idx === 0 ? "" : idx === 2 ? "0" : "1",
          })
        );
        break;
      case "collect first installment?":
        setApplyFilters({
          ...applyFilters,
          collect_first_installment: tabId,
        });
        dispatch(
          setFilters({
            ...applyFilters,
            collect_first_installment: tabId,
          })
        );
        break;
      default:
        break;
    }
  };

  const getLoanProduct = async (page) => {
    setLoading(true);
    const resp = await axios.post(
      `/loan/product/list/24/${page}`,
      applyFilters,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    setLoading(false);
    let totalProdCount = resp?.data?.total;
    let pageCount = Math.ceil(totalProdCount / 10);
    setTotalData(totalProdCount);
    setProductPages(pageCount);
    setLoanCounts(resp?.data?.counts);
    setLoanProducts(resp?.data?.data);
   // setAgentId(resp?.data?.data[0]?.inhouseAgent);
    console.log("setloanAgentId===============",agentId)
  };

  const ProductStatusChange = async (id, status) => {
    const resp = await axios.put(`loan/product/status/update/${id}/${status}`);
    if (resp.status < 400) {
      getLoanProduct(1);
      toast.success(resp.data?.message);
    }
  }
  const handlePagination = (e, val) => {
    setCurrentPage(val);
    getLoanProduct(val);
    window.scrollTo({ top: 0 });
  };
  const handleSwitchButton = (value) => {
    Reset()
    setSwitchButton(value);
    setApplyFilters({
      ...applyFilters,
      toggleSwitch: value ? "ht" : "lt",
    });
    dispatch(
      setFilters({
        ...applyFilters,
        toggleSwitch: value ? "ht" : "lt",
      })
    );
  };
  const getSettings = async () => {
    const resp = await axios.get("/settings");
    setSettingsData(resp?.data?.data);

  };

  const handleSortBy = (val) => {
    Reset();
    switch (val) {
      case "Featured":
        setApplyFilters({
          ...applyFilters,
          sortKey: "featured",
          sortOrder: "desc",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "featured",
            sortOrder: "desc",
          })
        );
        break;
      case "High to Low":
        setApplyFilters({
          ...applyFilters,
          sortKey: "interest",
          sortOrder: "desc",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "interest",
            sortOrder: "desc",
          })
        );
        break;
      case "Low to High":
        setApplyFilters({
          ...applyFilters,
          sortKey: "interest",
          sortOrder: "asc",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "interest",
            sortOrder: "asc",
          })
        );
        break;
      case "A to Z":
        setApplyFilters({
          ...applyFilters,
          sortKey: "name",
          sortOrder: "asc"
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "name",
            sortOrder: "asc",
          })
        );
        break;
      case "Z to A":
        setApplyFilters({
          ...applyFilters,
          sortKey: "name",
          sortOrder: "desc",
        });
        dispatch(
          setFilters({
            ...applyFilters,
            sortKey: "name",
            sortOrder: "desc",
          })
        );
        break;
      default:
        break;
    }
  };
  const handleTopFilters = (idx, tabId, tab) => {
    Reset();
    delete applyFilters[dynamicParam.parameter];
    setDynamicParam(tab);
    setTabIdx(idx);
    setApplyFilters({
      ...applyFilters,
      [tab.parameter]: tab.value,
      index: idx,
    });
    dispatch(
      setFilters({
        ...applyFilters,
        index: idx,
        [tab.parameter]: tab.value,
        topFilterParameter: tab.parameter,
      })
    );
  };

  const handleAgentBonusPop = (agent, bonus) => {
    const popData = {
      ...agent,
      allAgent: [bonus],
    };
    setallAgentData(popData);
    setbonusPopUp(true);
  };

  const handleinHouseAct = (state, id) => {
    if (state === "edit") {
      setinHouseModal(true);
      setinHouseEdit({
        ...inHouseEdit,
        prodEdit: true,
        id: id,
      });
    }
  };

  useEffect(() => {
    Reset();
    if (Object.keys(dynamicParam).length > 0) {
      applyFilters[dynamicParam.parameter] = dynamicParam.value;
      setApplyFilters({ ...applyFilters, index: tabIdx });
    }
  }, [dynamicParam]);

  const handleSearch = (e) => {
    Reset();
    setSearchKeyWord(e.target.value);
    setApplyFilters({ ...applyFilters, keyword: e.target.value });
    dispatch(
      setFilters({
        ...applyFilters,
        keyword: e.target.value,
      })
    );
  };
  useEffect(() => {
    getSettings();
  }, []);

  useEffect(() => {
    if (settingsData) {
      getLoanProduct(1);
    }
  }, [settingsData, applyFilters]);


  const handleScroll = () => {
    if (
      Math.round(window.innerHeight) +
      Math.round(document.documentElement.scrollTop) !==
      Math.round(document.documentElement.offsetHeight)
    ) {
      if (
        document.documentElement.offsetHeight -
        (window.innerHeight +
          Math.round(document.documentElement.scrollTop)) <=
        1
      ) {
        if (loanProducts?.length < totalData && !loading) {
          getLoanProduct(currentPage + 1, "scroll");
          setCurrentPage(currentPage + 1);
        }
      } else {
        return;
      }
    } else {
      if (loanProducts?.length < totalData && !loading) {
        getLoanProduct(currentPage + 1, "scroll");
        setCurrentPage(currentPage + 1);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading]);
  return (
    <div className="main_content flex-[1] bg-[#F5F5F5] w-[100%] min-h-screen">
      <ViewBonusPopup
        bonusPopUp={bonusPopUp}
        bonusData={allAgentData}
        closeBonusPop={() => setbonusPopUp(false)}
      />
      {!loanProducts && <PageLoader />}
      {inHouseModal && (
        <InHouseModal
          context={{
            settingsData,
            settingsIndex,
            setinHouseModal,
            getLoanProduct,
            inHouseEdit,
            applyFilters,
            settingsFilters: settingsIndex,
            agentId
          }}
        />
      )}
      <div className="bg-white">
        <div className="flex pt-[20px] justify-between items-center px-[24px] max-[600px]:flex-col max-[600px]:items-start">
          <div className="font-[700] text-[20px] max-[600px]:mb-[15px]">
            Manage Loan Product
          </div>
          <div className="flex items-center max-[600px]:w-full">
            <div className="relative w-[250px] max-w-[100%] max-[600px]:w-[100%]">
              <div className="absolute h-[100%] top-[0] left-[0] flex items-center max-[768px]:left-[10px] max-[768px]:top-[-2px]">
                <img
                  src="/images/search.svg"
                  alt="search"
                  className="pt-[3px]"
                />
              </div>
              <input
                type="search"
                placeholder="Search Product..."
                className="pl-[25px] outline-none text-[13px]  max-[768px]:border max-[768px]:border-gray-200 max-[768px]:p-[8px_20px_8px_33px] max-[768px]:rounded-[5px] max-[600px]:w-[calc(100%-50px)]"
                value={searchKeyWord}
                onChange={handleSearch}
              />
              <div
                className="h-[34px] w-[36px] bg-[#0560FB] hidden max-[600px]:inline-flex items-center justify-center rounded-[5px] ml-[10px] relative top-[2px]"
                onClick={() => setmobfilterBar(!mobfilterBar)}
              >
                <img
                  src="/images/filter_icon.png"
                  alt="filter"
                  className="max-w-[100%] h-auto"
                  width="14"
                  height="14"
                />
              </div>
            </div>
            {tabIdx === 4 && pagePermissions?.create_permission == 1 && (
              <Button
                type="button"
                className="sav_btn bonus_btn loan_prod ml-[5px!important]"
                onClick={() => {
                  setinHouseModal(true);
                  setinHouseEdit({ ...inHouseEdit, prodEdit: false });
                  // setinHouseEdit({ prodEdit: false, id: "" });
                }}
              >
                <img
                  src="/images/add-circle-wh.svg"
                  alt="add"
                  className="hidden max-[700px]:block"
                />
                <span className="max-[700px]:hidden">Create Loan Product</span>
              </Button>
            )}
          </div>
        </div>
        <div className="flex items-center justify-between mt-[12px] border-b-2 border-[#EAEAEA] px-[24px] max-[768px]:gap-[20px] max-[768px]:pr-[3px]">
          <div className="tab_Sec_box">
            <div className="tab_Sec flex ">
              {loanCounts &&
                loanCounts.topFilterCounts.map((tab, idx) => {
                  return (
                    <ButtonBase key={idx} className="topFilTabBtn">
                      <div
                        className={`tab_menu ${applyFilters?.index == idx && "active"
                          }`}
                        onClick={() => handleTopFilters(idx, tab.value, tab)}
                      >
                        <span className="inline-block">
                          {tab.label} ({tab.count})
                        </span>
                      </div>
                    </ButtonBase>
                  );
                })}
            </div>
          </div>
          <SortBy handleSortBy={handleSortBy} value={applyFilters} />
        </div>
        <div
          className={`backDrop ${!mobfilterBar && "hidden"}`}
          onClick={() => setmobfilterBar(false)}
        ></div>
        <div
          className={`switch_box_sec p-[10px_10px_5px_30px] min-[601px]:relative min-[601px]:pr-[140px] border-b-2 border-[#EAEAEA] ${mobfilterBar && "active"
            }`}
        >
          <div
            className="text-end mb-[15px] hidden max-[600px]:block"
            onClick={() => setmobfilterBar(false)}
          >
            <Close />
          </div>
          {settingsData && (
            <>
              <SwitchBox
                title="Vehicle"
                tabs={settingsData.vehicles}
                settingsHandle={settingsHandle}
                value={applyFilters?.vehicle}
              />
              <SwitchBox
                title="Type"
                tabs={settingsData.categories}
                settingsHandle={settingsHandle}
                value={applyFilters?.category}
              />
              <SwitchBox
                title="Category"
                tabs={settingsData.categories[settingsIndex.cat].types}
                settingsHandle={settingsHandle}
                value={applyFilters?.loanType}
              />
              <SwitchBox
                title="Motor"
                tabs={settingsData.productMotorTypes}
                settingsHandle={settingsHandle}
                value={applyFilters?.motorType}
              />
              <SwitchBox
                title="Usage"
                tabs={settingsData.productUsages}
                settingsHandle={settingsHandle}
                value={applyFilters?.usage}
              />
              <SwitchBox
                title="Scheme"
                tabs={
                  settingsData.categories[settingsIndex.cat].types[
                    settingsIndex.typ
                  ].schemes.map((scheme) => ({
                    ...scheme,
                    disabled:
                      settingsData.vehicles[settingsIndex.veh]?.name === 'Commercial' &&
                      scheme.name === 'Balloon',
                  }))
                }
                settingsHandle={settingsHandle}
                value={applyFilters?.scheme}
              />
              <br />
              <SwitchBox
                title="Approval Time"
                tabs={settingsData.approvalTimes}
                info="info"
                settingsHandle={settingsHandle}
                value={applyFilters?.approvalTime}
              />
              <SwitchBox
                title="Loan to Value"
                tabs={settingsData.ltvs}
                info="info"
                settingsHandle={settingsHandle}
                value={applyFilters?.ltv}
              />
              <SwitchBox
                title="Bonus"
                tabs={[
                  { name: "All", id: "" },
                  { name: "Yes", id: "1" },
                  { name: "No", id: "0" },
                ]}
                info="info"
                value={applyFilters?.bonus}
                settingsHandle={settingsHandle}
              />
              <SwitchBox
                title="Collect First Installment?"
                tabs={[{ name: "All", id: "" }].concat(
                  settingsData.collect_first_installment_options?.map((it) => {
                    return {
                      ...it,
                      id: it.value,
                    };
                  })
                )}
                info="info"
                settingsHandle={settingsHandle}
                value={applyFilters.collect_first_installment}
              />
              <SwitchButton
                labelLeft={"LT"}
                labelRight={"HT"}
                right={applyFilters?.toggleSwitch === "ht" ? true : false}
                handleSwitchButton={handleSwitchButton}
              />
            </>
          )}
        </div>
      </div>
      <div className="p-[50px_25px]">
        <div className="flex flex-wrap gap-[60px_20px]">
          {loading ? (
            <LoaderComp />
          ) : (
            <>
              {loanProducts && (
                <>
                  {loanProducts.length > 0 ? (
                    loanProducts.map((item) => {
                      const interestRates = item.interests.map((interest) =>
                        parseFloat(interest.interest)
                      );
                      const lowestInterestIndex = interestRates.indexOf(
                        Math.min(...interestRates)
                      );
                      const highestInterestIndex = interestRates.indexOf(
                        Math.max(...interestRates)
                      );
                      return (
                        <BankCard
                          product={item}
                          key={item.id}
                          inHouseAct={handleinHouseAct}
                          topTab={tabIdx}
                          allAgentBonus={handleAgentBonusPop}
                          interestSort={
                            switchButton
                              ? lowestInterestIndex
                              : highestInterestIndex
                          }
                          interestToggle={applyFilters.toggleSwitch}
                          pagePermissions={pagePermissions}
                          authData={authData}
                          ProductStatusChange={ProductStatusChange}
                        />
                      );
                    })
                  ) : (
                    <h2 className="font-[700] text-2xl text-center w-full">
                      No Products
                    </h2>
                  )}
                </>
              )}
            </>
          )}
        </div>
        {!loading && (
          <>
            {productPages > 1 && (
              <div className="flex flex-col items-center mt-[35px]">
                <Pagination
                  count={productPages}
                  page={currentPage}
                  onChange={handlePagination}
                  variant="outlined"
                  color="primary"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default LoanProduct;
